import type { UUID } from '@/utils/uuid';

import { useListMyPermissions } from './use-fetch-my-permissions';

/**
 * Whether the current user holds `permission` in the tenant, by exact name.
 * Loading lasts until the tenant resolves and its permissions arrive; a failed
 * load denies.
 */
export function useHasPermission(
  tenantId: UUID | undefined,
  permission: string
): { allowed: boolean; isLoading: boolean } {
  const { data, isPending } = useListMyPermissions(tenantId);
  return {
    allowed: data?.includes(permission) ?? false,
    isLoading: isPending,
  };
}
